module.exports = __webpack_public_path__ + "static/media/person7.68bf6252.png";